module.exports = __webpack_public_path__ + "static/img/p3-4.e6b8c77.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p3-4.jpg
// module id = 03Ll
// module chunks = 1